module.exports = __webpack_public_path__ + "static/media/gatorclaw.f9d4c624.svg";